import { demutate, mutate, mutationTypes, updateWord } from './mutationUtils';

export const lowercaseSpiranteMutations = {
  'k': 'c\'h',
  'p': 'f',
  't': 'z',
};

const spiranteMutations = {
  'k': 'c\'h',
  'p': 'f',
  't': 'z',
  'K': 'C\'H',
  'P': 'F',
  'T': 'Z',
};

const reverseMutations = {
  'c\'h': 'k',
  'f': 'p',
  'z': 't',
  'C\'H': 'K',
  'C\'h': 'K',
  'F': 'P',
  'Z': 'T',
};

export const provokersSpiranteMutationsOnly = [
  'he', 'hon', 'tri', 'teir', 'pevar', 'peder', 'nav', 'am',
];

export function applySpiranteMutations (wordToMutateIdx, words) {

  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, spiranteMutations, mutationTypes.SPIRANTE);
    },
    (word) => {
      demutate(word, reverseMutations, mutationTypes.SPIRANTE);
    });
}
